import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import OnboardingContext from '../common/context';
import Product from './product';

const Container = styled.div`
  margin-top: 20px;
  border: 0;
  border-top: 1px solid ${props => props.theme.secondaryColorLight};
  display: flex;
  flex-direction: column;
  align-items: center;

  ${props => (props.theme.isMobile ? `
    width: 100%;
  ` : `
    width: 36vw;
    max-width: 461px;
  `)}

  & > div {
    width: 100%;
    padding-right: ${props => (props.theme.isMobile ? '4px' : '20px')};
  }
`;
const Text = styled.p`
  font: ${props => props.theme.fontWeightHeavy} 12px/1 ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.bodyColor};
`;

const Description = styled(Text)`
  margin: 8.5px 0;
  text-transform: uppercase;
  align-self: flex-start;
`;

const Message = styled(Text)`
  margin: 0;
  margin-top: 5px;
  align-self: flex-end;

  & > em {
    font-style: normal;
    color: ${props => props.theme.primaryColor};
  }
`;

const More = ({ n }) => {
  if (!n) {
    return null;
  }

  /* eslint-disable react/jsx-one-expression-per-line */
  return (
    <Message>…and <em>{n} more</em> listed {n > 1 ? 'products' : 'product'}</Message>
  );
  /* eslint-enable react/jsx-one-expression-per-line */
};

More.propTypes = {
  n: PropTypes.number.isRequired,
};

export default function Following() {
  const { state } = React.useContext(OnboardingContext);

  const showing = state.productsFollowing.slice(0, 3);

  if (!showing.length) {
    return null;
  }

  return (
    <Container>
      <Description>You’re now following</Description>
      <div>
        {showing.map(p => <Product {...p} followed key={p.slug} />)}
      </div>
      <More n={state.productsFollowing.length - showing.length} />
    </Container>
  );
}
